import { render, staticRenderFns } from "./createChannel.vue?vue&type=template&id=74f35020&"
import script from "./createChannel.vue?vue&type=script&lang=js&"
export * from "./createChannel.vue?vue&type=script&lang=js&"
import style0 from "./createChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports